import { render, staticRenderFns } from "./ModalRegistAcademy.vue?vue&type=template&id=0f5edba4&scoped=true&lang=pug&"
import script from "./ModalRegistAcademy.vue?vue&type=script&lang=ts&"
export * from "./ModalRegistAcademy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5edba4",
  null
  
)

export default component.exports